import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faCalendarAlt, faDollarSign, faEdit, faHashtag, faPercentage, faPrint, faTimes } from '@fortawesome/free-solid-svg-icons';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import PDFFactAportesMunicipales from './PDFFactAportesMunicipales';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        valor_factura: '',
        valor_cartera: '',
        factura_aporte: [],
        departamentosAporte: [],
        municipiosAporte: [],
        periodos: [],
        datosAportesMunicipales: [],
        errores: [],
        filename: ''
    }
    cambioValor = (e) => {
        const state = this.state.factura_aporte;
        state[e.target.name] = e.target.value;
        this.setState({ factura_aporte: state });
    };
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const fecha_factura = document.getElementById('fecha_factura').value;
        const fecha_entrega = document.getElementById('fecha_entrega').value;
        const fecha_vencimiento = document.getElementById('fecha_vencimiento').value;
        const estado_factura = document.getElementById('ESTADO_FACTURA').value;
        const consecutivo_fact = document.getElementById('consecutivo_fact').value;
        const id_departamento = document.getElementById('ID_COD_DPTO').value;
        const id_municipio = document.getElementById('ID_COD_MPIO').value;
        const periodo_factura = document.getElementById('PERIODO_FACTURA').value;
        const cc_vencidas = document.getElementById('cc_vencidas').value;
        const valor_factura = document.getElementById('valor_factura').value;
        const valor_cartera = document.getElementById('valor_cartera').value;
        var errores = [];
        if (!fecha_factura) { errores.push("error_fecha_factura"); }
        if (!fecha_entrega) { errores.push("error_fecha_entrega"); }
        if (!fecha_vencimiento) { errores.push("error_fecha_vencimiento"); }
        if (!estado_factura) { errores.push("error_estado_factura"); }
        if (!consecutivo_fact) { errores.push("error_consecutivo_fact"); }
        if (!id_departamento) { errores.push("error_id_departamento"); }
        if (!id_municipio) { errores.push("error_id_municipio"); }
        if (!periodo_factura) { errores.push("error_periodo_factura"); }
        if (!cc_vencidas) { errores.push("error_cc_vencidas"); }
        if (!valor_factura) { errores.push("error_valor_factura"); }
        if (!valor_cartera) { errores.push("error_valor_cartera"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        console.log(formData);
        Swal.showLoading();
        authAxios.post("fact_aportes/editar", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                Swal.close();
                Swal.fire(
                    'Facturación Aportes!',
                    datosRespuesta.data.msj,
                    'success'
                )
                this.props.history.push("/MasterFactAportesMunicipales");
            })
            .catch(console.log)
    }
    cargarMunicipios() {
        var id_departamento = document.getElementById('ID_COD_DPTO').value;
        Swal.showLoading();
        authAxios.get("municipios_visitas/buscardepartamento/" + id_departamento)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, municipiosAporte: datosRespuesta.data, load: '' });
                this.cargarValores();
                Swal.close();
            })
            .catch(console.log);
    }
    cargarValores() {
        Swal.showLoading();
        var id_departamento = document.getElementById("ID_COD_DPTO").value;
        var id_municipio = document.getElementById("ID_COD_MPIO").value;
        authAxios.get("alcaldia/cargar_valores/" + id_departamento + "/" + id_municipio)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({
                    datosCargados: true,
                    valor_factura: datosRespuesta.data.VALOR_CONCEPTO,
                    valor_cartera: datosRespuesta.data.VALOR_CARTERA,
                    load: ''
                });
                Swal.close();
            })
            .catch(console.log);
    }
    previewPDFFactAportesMunicipales = (id_fact) => {
        authAxios.get(`fact_aportes/generar_factura/${id_fact}`)
            .then((response) => {
                var status = response.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                const filename = `AGM - Factura Cliente Municipal ${response.data.resultAll.itemResultAporte.MUNICIPIO} - ${response.data.resultAll.itemResultAporte.PERIODO_FACTURA}.pdf`
                this.setState({datosAportesMunicipales: response.data.resultAll, filename: filename})
            })
            .catch((error) =>  console.log(error))
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("fact_aportes/periodos_fact")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, periodos: datosRespuesta.data, load: '' });
            })
            .catch(console.log);
        authAxios.get("fact_aportes/ver/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true,
                                factura_aporte: datosRespuesta.data.resultado,
                                load: '' });
                var id_departamento = datosRespuesta.data.resultado.ID_COD_DPTO;
                var id_municipio = datosRespuesta.data.resultado.ID_COD_MPIO;
                document.getElementById("ID_COD_DPTO").value = id_departamento;
                document.getElementById("ID_COD_MPIO").value = id_municipio;
            })
            .catch(console.log);
        authAxios.get("departamentos_visitas/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, departamentosAporte: datosRespuesta.data.data, load: '' });
                this.cargarMunicipios();
            })
            .catch(console.log);
    }

    render() {
        const { load, valor_factura, valor_cartera, factura_aporte, periodos, departamentosAporte, municipiosAporte, datosAportesMunicipales, filename } = this.state;
        return (
            <>
                <div className="content-wrapper">
                    <div className="content">
                        <div className="container-fluid">
                            <br />
                            <div className="card">
                                <div className="card-header text-center">
                                    {load ? (<b>{load}</b>) : (<b>EDITAR FACTURA APORTES MUNICIPALES</b>)}
                                </div>
                                <div className="card-body">
                                    <form onSubmit={this.enviarDatos} id="form">
                                        <div className="row">
                                            <div className="col-xl-12">
                                                <div className='row g-3'>
                                                    <div className="col-md-2">
                                                        <input type="hidden" name="id_facturacion" value={this.props.match.params.id} />
                                                        <input type="hidden" name="id_usuario" id="id_usuario" value={window.localStorage.getItem('idusuario')} />
                                                        <label htmlFor="fecha_factura">Fecha Factura</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_factura" id="fecha_factura" defaultValue={factura_aporte.FECHA_FACTURA}
                                                                className={((this.verificarError("error_fecha_factura")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Fecha Factura" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Seleccione la Fecha Factura</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="fecha_entrega">Fecha Entrega</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_entrega" id="fecha_entrega" defaultValue={factura_aporte.FECHA_ENTREGA}
                                                                className={((this.verificarError("error_fecha_entrega")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Fecha Entrega" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Seleccione la Fecha Entrega</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="fecha_vencimiento">Fecha Vencimiento</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_vencimiento" id="fecha_vencimiento" defaultValue={factura_aporte.FECHA_VENCIMIENTO}
                                                                className={((this.verificarError("error_fecha_vencimiento")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Fecha Vencimiento" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Seleccione la Fecha Vencimiento</small>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="PERIODO_FACTURA">Periodo Factura</label>
                                                        <select name="PERIODO_FACTURA"
                                                            id="PERIODO_FACTURA"
                                                            value={factura_aporte.PERIODO_FACTURA}
                                                            options={factura_aporte.PERIODO_FACTURA}
                                                            onChange={this.cambioValor}
                                                            className={((this.verificarError("error_periodo_factura")) ? "is-invalid" : "") + " form-select form-select-sm"}>
                                                            <option value="">Seleccione el Periodo Factura</option>
                                                            {
                                                                periodos.map((itemPeriodos) => (
                                                                    <option key={itemPeriodos.ID_TABLA} value={itemPeriodos.ANO_FACTURA + "" + itemPeriodos.MES_FACTURA}>{itemPeriodos.PERIODO} - {itemPeriodos.ANO_FACTURA}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <small id="helpId" className="invalid-feedback">Seleccione el Periodo Factura</small>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="ESTADO_FACTURA">Estado Factura</label>
                                                        <select name="ESTADO_FACTURA"
                                                            id="ESTADO_FACTURA"
                                                            value={factura_aporte.ESTADO_FACTURA}
                                                            options={factura_aporte.ESTADO_FACTURA}
                                                            className={((this.verificarError("error_estado_factura")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                            onChange={this.cambioValor}>
                                                                <option value="">Seleccione el Estado Factura</option>
                                                                <option value="1">ENTREGADO</option>
                                                                <option value="2">PENDIENTE DE ENVÍO</option>
                                                                <option value="3">RECLAMADA</option>
                                                        </select>
                                                        <small id="helpId" className="invalid-feedback">Seleccione el Estado Factura</small>
                                                    </div>
                                                </div>
                                                <hr style={{ marginBottom: 0 }} />
                                                <div style={{ fontSize: 14 }} className="card-header text-center">
                                                    <b>INFORMACIÓN MUNICIPIO</b>
                                                </div>
                                                <div style={{ marginTop: 0 }} className='row g-3'>
                                                    <div className="col-md-3">
                                                        <label htmlFor="ID_COD_DPTO">Departamento</label>
                                                        <select name="ID_COD_DPTO"
                                                            id="ID_COD_DPTO"
                                                            value={factura_aporte.ID_COD_DPTO}
                                                            options={factura_aporte.ID_COD_DPTO}
                                                            onChange={e => {
                                                                this.cargarMunicipios(e);
                                                                this.cambioValor(e)
                                                            }}
                                                            className={((this.verificarError("error_id_departamento")) ? "is-invalid" : "") + " form-select form-select-sm"}>
                                                            <option value="">Seleccione el Departamento</option>
                                                            {
                                                                departamentosAporte.map((itemDepartamentosAporte) => (
                                                                    <option key={itemDepartamentosAporte.ID_TABLA} value={itemDepartamentosAporte.ID_DEPARTAMENTO}>{itemDepartamentosAporte.NOMBRE}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="ID_COD_MPIO">Municipio</label>
                                                        <select name="ID_COD_MPIO"
                                                            id="ID_COD_MPIO"
                                                            value={factura_aporte.ID_COD_MPIO}
                                                            options={factura_aporte.ID_COD_MPIO}
                                                            className={((this.verificarError("error_id_municipio")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                            onChange={(e) => {
                                                                this.cambioValor(e);
                                                                this.cargarValores(e);
                                                            }}>
                                                            <option value="">Seleccione el Municipio</option>
                                                            {
                                                                municipiosAporte.map((itemMunicipiosAporte) => (
                                                                    <option key={itemMunicipiosAporte.ID_TABLA} value={itemMunicipiosAporte.ID_MUNICIPIO}>{itemMunicipiosAporte.NOMBRE}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <small id="helpId" className="invalid-feedback">Seleccione el Municipio</small>
                                                    </div>
                                                </div>
                                                <hr style={{ marginBottom: 0 }} />
                                                <div style={{ fontSize: 14 }} className="card-header text-center">
                                                    <b>INFORMACIÓN VALORES FACTURA</b>
                                                </div>
                                                <div style={{ marginTop: 0 }} className='row g-3'>
                                                    <div className="col-md-2">
                                                        <label htmlFor="consecutivo_fact">Consecutivo Factura</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="consecutivo_fact" id="consecutivo_fact" defaultValue={factura_aporte.CONSECUTIVO_FACT}
                                                                className={((this.verificarError("error_consecutivo_fact")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Consecutivo Fact." aria-describedby="helpId"
                                                                onChange={this.cambioValor} readOnly
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Digite el Consecutivo Factura</small>
                                                    </div>
                                                </div>
                                                <div style={{ marginTop: 0 }} className='row g-3'>
                                                    <div className="col-md-2">
                                                        <label htmlFor="cc_vencidas">C.C. Vencidas</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="cc_vencidas" id="cc_vencidas" defaultValue={factura_aporte.NO_CC_VENCIDAS}
                                                                className={((this.verificarError("error_cc_vencidas")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="C.C. Vencidas" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Digite las C.C. Vencidas</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="valor_factura">Valor Factura</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="valor_factura" id="valor_factura" defaultValue={valor_factura}
                                                                className={((this.verificarError("error_valor_factura")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Factura" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Digite el Valor Factura</small>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="valor_cartera">Valor Cartera</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="valor_cartera" id="valor_cartera" defaultValue={valor_cartera}
                                                                className={((this.verificarError("error_valor_cartera")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Cartera" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Digite el Valor Cartera</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className='row'>
                                            <div className='col-xl-12 text-center'>
                                                <div className="btn-group" role="group" aria-label="">
                                                    <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar Fact. Aportes Munc.</button>&nbsp;&nbsp;
                                                    <Link className="btn btn-danger btn-sm" to={"/MasterFactAportesMunicipales"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>&nbsp;&nbsp;
                                                    <button type="button" className="btn btn-secondary btn-sm" data-bs-toggle='modal' data-bs-target="#PDFFactAportesMunicipalesModal" slot='end'
                                                        onClick={() => {
                                                            this.previewPDFFactAportesMunicipales(this.props.match.params.id)
                                                        }}
                                                    >
                                                        <FontAwesomeIcon icon={faPrint} /> &nbsp;&nbsp;Imprimir Factura
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="PDFFactAportesMunicipalesModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="ActaInterventoriaoLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className='col-9'>
                                    <h4 className="modal-title w-100 text-center" id="">Facturación Aportes Municipales</h4>
                                </div>
                                <div className='col-2'>
                                    <PDFDownloadLink
                                        document={<PDFFactAportesMunicipales data={datosAportesMunicipales} />}
                                        fileName={filename}
                                    >
                                        {({ loading }) =>
                                            loading ? "Loading..." : <button className="btn btn-success"> Descargar PDF <FontAwesomeIcon icon={faPrint} /></button>
                                        }
                                    </PDFDownloadLink>
                                </div>
                                <div className='col-1'>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <PDFViewer style={{ width: "100%", height: "90vh" }}>
                                            <PDFFactAportesMunicipales data={datosAportesMunicipales} />
                                        </PDFViewer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Editar;